import React, { Component } from 'react';
import { get, has } from "lodash"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import StepControl from "../stepControl"
import { sexData } from "../sex/static.sexData"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { steps } from "../../../shared/static.steps"
import locales from "../../../content.json";
import ButtonFill from "../../../shared/items/controls/buttonFill"
import getParameterFromURL from "../../../utils/getParameterFromUrl"
import styles from './firstPageQuestionC.module.scss'
import "./../../../shared/services/service.step.scss"

import maleL from "./img/man-left.png"
import maleR from "./img/man-right.png"
import femaleL from "./img/female-left.png"
import femaleBg from "./img/female-bg.png"
import femaleR2 from "./img/female-right-2.png"

let questionCFemale = (getParameterFromURL("questionCFemale") === "true");

class FirstPageQuestionC extends Component {
  constructor() {
    super();

    this.state = {
      isOpenFirstPageQuestionC: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.firstPageQuestionC) && !this.state.isOpenFirstPageQuestionC)
      this.setState({ isOpenFirstPageQuestionC: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenFirstPageQuestionC } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.firstPageQuestionC,
      isOpen: isOpenFirstPageQuestionC,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenFirstPageQuestionC && !has(data, ["firstPageQuestionC"]))
      onSetStepData("firstPageQuestionC")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenFirstPageQuestionC: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenFirstPageQuestionC } = this.state
    const params = {
      className: "firstPageQuestionC",
      currentIndex: currentIndex,
      stepIndex: steps.firstPageQuestionC,
    }

    return isOpenFirstPageQuestionC && !questionCFemale ?
      <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
        <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
            <div className={styles.container}>
              <div className={styles.title}>
                {locales[window.userLang].firstQuestionC_title}
              </div>
              <div className={styles.gender} onClick={() => {
                onUpdateStepData.bind(this, "sex", "value", "male")();
                this.props.onToNextStep()
              }}>
                <div className={styles.genderButton}>
                  <img src={maleL} alt="before-male"/>
                  <div className={styles.genderButton_choice}>
                    {locales[window.userLang].firstQuestionС_button_no}
                  </div>
                </div>
                <div className={styles.genderButton}>
                  <img src={maleR} alt="after-male"/>
                  <div className={styles.genderButton_choice_active}>
                    {locales[window.userLang].firstQuestionС_button_yes}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      : 
      questionCFemale ? <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
        <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
            <div className={styles.container}>
              <div className={styles.title}>
                {locales[window.userLang].firstQuestionC_title}
              </div>
              <div className={styles.gender} onClick={() => {
                onUpdateStepData.bind(this, "sex", "value", "female")();
                this.props.onToNextStep()
              }}>
                <div className={styles.genderButton}>
                  <img src={femaleL} alt="before-male"/>
                  <div className={styles.genderButton_choice}>
                    {locales[window.userLang].firstQuestionС_button_no}
                  </div>
                </div>
                <div className={styles.genderButton}>
                  <img src={femaleBg} alt="after-female"/>
                  <img className={styles.o_curva} src={femaleR2} alt="after-female"/>
                  <div className={styles.genderButton_choice_active}>
                    {locales[window.userLang].firstQuestionС_button_yes}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div> : null;
  }
}

export default withStepsState(FirstPageQuestionC);